export function isTrue(input: string): boolean {
  return input === "true";
}

export function stripSpaces(input: string): string {
  return input.replace(/\s/g, "");
}

export function coerceValue(value: string): boolean | string | number {
  if (isTrue(value)) return true;
  if (value === "false") return false;
  if (!isNaN(Number(value))) return Number(value);
  return value;
}

export function replaceNewLinesWithBr(text: string): string {
  return text.replace(/\n/g, "<br />");
}
